var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card',{attrs:{"title":_vm.title}},[(_vm.loadData)?_c('dynamic-generator-form',{attrs:{"form":_vm.loadData,"configData":_vm.configData,"isCreateForm":_vm.isCreateForm,"pageMode":_vm.pageMode}}):_vm._e(),_vm._t("default"),_vm._t("block4"),_vm._t("block3"),_vm._t("block2")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }